import { Injectable, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import { environment } from '../environments/environment';
import {
  blockTikTokPixelInRestrictedInAppBrowser,
  isRestrictedInAppBrowser,
} from './in-app-browser';

@Injectable({ providedIn: 'root' })
export class GtmInitializerService {
  private isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  initGtm(): void {
    if (!this.isBrowser) return;

    const src = `https://www.googletagmanager.com/gtm.js?id=${environment.GTM_ID}`;
    if (document.querySelector(`script[src="${src}"]`)) {
      return;
    }

    const restrictedInAppBrowser = isRestrictedInAppBrowser();
    if (restrictedInAppBrowser) {
      blockTikTokPixelInRestrictedInAppBrowser();
    }

    const w = window as Window & { dataLayer?: Record<string, unknown>[] };
    w.dataLayer = w.dataLayer || [];
    if (restrictedInAppBrowser) {
      w.dataLayer.push({ in_app_browser: true });
    }
    w.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });

    const gtmScript = document.createElement('script');
    gtmScript.async = true;
    gtmScript.src = src;
    document.head.appendChild(gtmScript);
  }
}
